import { render, staticRenderFns } from "./MelonTVBanner.vue?vue&type=template&id=6ecb358e&"
import script from "./MelonTVBanner.vue?vue&type=script&lang=js&"
export * from "./MelonTVBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports